<div class="home-page-v2">
    <!--    ONE COL CAROUSEL BANNER VERSION 2-->
    <div
        *ngIf="item?.layoutType === '1-col-carousel-banner-v2'"
        class="one-col-carousel-v2"
        ngClass.xs="one-col-carousel-v2-mobile"
    >
        <swiper
            [virtual]="false"
            [navigation]="true"
            [autoplay]="{ speed: 3000, disableOnInteraction: false }"
            [pagination]="false"
            [slidesPerView]="1"
            [spaceBetween]="20"
            [loop]="true"
            (swiper)="homepageService.onSwiper($event)"
        >
            <ng-template
                *ngFor="let carouselImage of item?.layoutContent?.feed"
                swiperSlide
            >
                <div
                    class="
                        one-col-banner-carousel one-col-banner-carousel-mobile
                    "
                    ngClass.gt-xs="one-col-banner-carousel-desktop"
                >
                    <a
                        [routerLink]="[
                            carouselImage?.banner?.link | pageIdFromLink
                        ]"
                        [queryParams]="
                            carouselImage?.banner?.link | queryParamFromLink
                        "
                        [attr.aria-label]="
                            carouselImage?.title?.text || 'banner-link'
                        "
                    >
                        <picture
                            class="one-col-banner-image"
                            [ngClass]="{
                                'image-banner-shimmer': showShimmer
                            }"
                        >
                            <img
                                src="{{ carouselImage?.banner?.image }}"
                                class="image-holder"
                                appImageCDN
                                [style]="{
                                    cursor:
                                        carouselImage?.banner?.link &&
                                        carouselImage?.banner?.link !== ''
                                            ? 'pointer'
                                            : 'auto'
                                }"
                                [alt]="carouselImage?.title?.text || 'banner'"
                            />
                        </picture>
                    </a>
                </div>
                <div
                    class="one-col-carousel-banner-v2-content"
                    ngClass.xs="__mobile"
                    ngClass.gt-xs="__desktop"
                >
                    <a
                        *ngIf="carouselImage?.title?.text"
                        [routerLink]="[
                            carouselImage?.banner?.link | pageIdFromLink
                        ]"
                        [queryParams]="
                            carouselImage?.banner?.link | queryParamFromLink
                        "
                        style="text-decoration: none"
                        [attr.aria-label]="
                            carouselImage?.title?.text || 'banner-link'
                        "
                    >
                        <h1
                            *ngIf="carouselImage?.title?.text"
                            style="color: {{ carouselImage?.title?.color }}"
                            class="carousel-banner-heading-v2"
                            ngClass.xs="carousel-banner-heading-v2-mobile"
                            >{{ carouselImage?.title?.text }}</h1
                        >
                    </a>
                    <p
                        *ngIf="carouselImage?.subtitle?.text"
                        class="carousel-banner-subtext-v2"
                        ngClass.xs="carousel-banner-heading-v2-mobile"
                        [innerHTML]="carouselImage?.subtitle?.text | lineBreak"
                    ></p>
                    <a
                        *ngIf="carouselImage?.button?.title?.text"
                        [routerLink]="[
                            carouselImage?.button?.link | pageIdFromLink
                        ]"
                        [queryParams]="
                            carouselImage?.button?.link | queryParamFromLink
                        "
                        style="text-decoration: none"
                        [attr.aria-label]="
                            carouselImage?.title?.text || 'button-link'
                        "
                    >
                        <button
                            mat-flat-button
                            class="button-v2"
                            style="background: {{
                                carouselImage?.button?.background?.color
                            }};
            color:{{ carouselImage?.button?.title?.color }}"
                            *ngIf="!!carouselImage?.button"
                        >
                            {{ carouselImage?.button?.title?.text }}
                        </button>
                    </a>
                </div>
            </ng-template>
        </swiper>
    </div>

    <!--  TWO COL SLIDER VERSION 2-->

    <div
        *ngIf="item?.layoutType === '2-col-slider-v2'"
        class="two-col-slider-v2"
    >
        <div fxLayout="row" style="margin: 0 34px 98px 106px">
            <div
                fxLayout="column"
                fxLayoutAlign="center"
                style="margin: 0 116px 0 0; width: 18.64%"
            >
                <h1
                    *ngIf="item?.layoutContent?.title?.text"
                    class="two-col-slider-title-v2"
                    style="color: {{ item?.layoutContent?.title?.color }}"
                    >{{ item?.layoutContent?.title?.text }}</h1
                >
                <p
                    *ngIf="item?.layoutContent?.subtitle?.text"
                    style="color: {{ item?.layoutContent?.subtitle?.color }}"
                    class="two-col-slider-subtitle-v2"
                    >{{ item?.layoutContent?.subtitle?.text }}</p
                >
                <a
                    *ngIf="item?.layoutContent?.button?.title?.text"
                    [routerLink]="[
                        item?.layoutContent?.button?.link | pageIdFromLink
                    ]"
                    [queryParams]="
                        item?.layoutContent?.button?.link | queryParamFromLink
                    "
                    style="text-decoration: none"
                    [attr.aria-label]="
                        item?.layoutContent?.title?.text || 'button-link'
                    "
                >
                    <button
                        *ngIf="item?.layoutContent?.button"
                        mat-flat-button
                        class="button-v2"
                        style="background: {{
                            item?.layoutContent?.button?.background?.color
                        }};
            color:{{ item?.layoutContent?.button?.title?.color }}"
                        >{{ item?.layoutContent?.button?.title?.text }}</button
                    >
                </a>
            </div>

            <swiper
                style="width: 75%"
                [slidesPerView]="4"
                [slidesPerGroup]="4"
                [speed]="1300"
                [navigation]="true"
                [spaceBetween]="16"
                [effect]="'flip'"
                (swiper)="homepageService.onSwiper($event)"
                (slideChange)="homepageService.onSlideChange($event)"
            >
                <ng-template
                    swiperSlide
                    *ngFor="let feedItem of item?.layoutContent?.slider"
                >
                    <a
                        *ngIf="feedItem?.banner?.image"
                        [routerLink]="[feedItem?.banner?.link | pageIdFromLink]"
                        [queryParams]="
                            feedItem?.banner?.link | queryParamFromLink
                        "
                        [attr.aria-label]="
                            feedItem?.title?.text || 'banner-link'
                        "
                    >
                        <picture
                            [ngClass]="{
                                'image-slider-v2-shimmer': showShimmer
                            }"
                        >
                            <img
                                style="width: 100%; cursor: pointer"
                                [ngStyle.gt-xs]="{ marginBottom: '14.4px' }"
                                src="{{ feedItem?.banner?.image }}"
                                appImageCDN
                                [alt]="feedItem?.title?.text || 'banner'"
                            />
                        </picture>
                    </a>
                    <div fxLayout="column">
                        <span
                            *ngIf="feedItem?.subtitle"
                            style="text-align: left; margin-bottom: 7px; font-size: 13px; color: {{
                                feedItem?.subtitle?.color
                            }}"
                            [ngStyle.xs]="{
                                marginBottom: '5px',
                                fontSize: '12px'
                            }"
                        >
                            {{ feedItem?.subtitle?.text }}
                        </span>
                        <a
                            *ngIf="feedItem?.title?.text"
                            [routerLink]="[
                                feedItem?.banner?.link | pageIdFromLink
                            ]"
                            [queryParams]="
                                feedItem?.banner?.link | queryParamFromLink
                            "
                            style="text-decoration: none"
                            [attr.aria-label]="
                                feedItem?.title?.text || 'banner-link'
                            "
                        >
                            <span
                                [ngStyle.gt-xs]="{
                                    '-webkit-line-clamp': '2',
                                    fontSize: '13px',
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    '-webkit-box-orient': 'vertical',
                                    textOverflow: 'ellipsis',
                                    width: '100%'
                                }"
                                style="color: {{ feedItem?.title?.color }}"
                                *ngIf="feedItem?.title"
                                class="slider-title"
                            >
                                {{ feedItem?.title?.text }}
                            </span>
                        </a>
                    </div>
                </ng-template>
            </swiper>
        </div>
    </div>

    <!--  COLLECTION BANNER LAYOUT VERSION 2-->

    <div *ngIf="item?.layoutType === 'collections-banner-v2'">
        <div
            *ngIf="item?.layoutContent?.slider?.length > 0"
            style="margin: 0 34px 98px 34px"
            [ngStyle.xs]="{ margin: '0 0px 72px 16px' }"
            fxLayout.gt-xs="column"
            fxLayoutAlign.gt-xs="center center"
            class="collections-banner-v2"
        >
            <div
                fxLayoutAlign="space-between"
                [ngStyle.xs]="{ marginBottom: '16px', marginRight: '16px' }"
            >
                <span
                    *ngIf="item?.layoutContent?.title?.text"
                    class="collections-banner-title-v2"
                    ngClass.xs="collections-banner-title__mobile"
                    [ngStyle.gt-xs]="{
                        marginBottom: item?.layoutContent?.subtitle?.text
                            ? '0'
                            : '50px'
                    }"
                    style="color:{{ item?.layoutContent?.title?.color }}"
                    >{{ item?.layoutContent?.title?.text }}</span
                >
                <a
                    *ngIf="item?.layoutContent?.button?.title?.text"
                    [routerLink]="[
                        item?.layoutContent?.button?.link | pageIdFromLink
                    ]"
                    [queryParams]="
                        item?.layoutContent?.button?.link | queryParamFromLink
                    "
                    style="text-decoration: none"
                    [attr.aria-label]="
                        item?.layoutContent?.title?.text || 'button-link'
                    "
                >
                    <button
                        *ngIf="item?.layoutContent?.button?.title?.text"
                        fxShow.gt-xs="false"
                        fxShow.xs="true"
                        class="view-button"
                        style="color: {{
                            item?.layoutContent?.button?.title?.color
                        }}"
                        >{{ item?.layoutContent?.button?.title?.text }}</button
                    >
                </a>
            </div>
            <p
                *ngIf="item?.layoutContent?.subtitle?.text"
                fxShow.xs="false"
                class="collections-banner-sub-title-v2"
                [innerHTML]="item?.layoutContent?.subtitle?.text | lineBreak"
            ></p>
            <div
                *ngIf="item?.layoutContent?.slider"
                fxLayout.gt-xs="row wrap"
                fxLayout.xs="row"
                fxLayoutAlign="space-between"
                [ngStyle.gt-xs]="{
                    marginBottom: item?.layoutContent?.button?.title?.text
                        ? '50px'
                        : '0px'
                }"
                [ngStyle.xs]="{
                    overflowX: 'auto',
                    gap: '12px',
                    paddingRight: '16px'
                }"
                ngClass.xs="scrollBar-v2"
            >
                <div
                    *ngFor="let feedItem of item?.layoutContent?.slider"
                    fxFlex="32%"
                    fxLayout="column"
                    [ngStyle.xs]="{
                        marginBottom: iosWeb ? '0' : '16px'
                    }"
                    fxFlex.xs="0 0 77.37%"
                >
                    <a
                        *ngIf="feedItem?.banner?.image"
                        [routerLink]="[feedItem?.banner?.link | pageIdFromLink]"
                        [queryParams]="
                            feedItem?.banner?.link | queryParamFromLink
                        "
                        style="text-decoration: none"
                        [attr.aria-label]="
                            feedItem?.title?.text || 'banner-link'
                        "
                    >
                        <picture
                            [ngClass]="{
                                'collections-image-shimmer': showShimmer
                            }"
                        >
                            <img
                                style="width: 100%; cursor: pointer"
                                src="{{ feedItem?.banner?.image }}"
                                appImageCDN
                                [alt]="feedItem?.title?.text || 'banner'"
                            />
                        </picture>
                    </a>
                    <a
                        *ngIf="feedItem?.title?.text"
                        [routerLink]="[feedItem?.banner?.link | pageIdFromLink]"
                        [queryParams]="
                            feedItem?.banner?.link | queryParamFromLink
                        "
                        style="text-decoration: none"
                        [attr.aria-label]="
                            feedItem?.title?.text || 'banner-link'
                        "
                    >
                        <span
                            *ngIf="feedItem?.title?.text"
                            class="collection-banner-v2-text__title"
                            ngClass.xs="collection-banner-v2-text__title-mobile"
                            style="color: {{ feedItem?.title?.color }}"
                        >
                            {{ feedItem?.title?.text }}
                        </span>
                    </a>
                    <span
                        *ngIf="feedItem?.subtitle?.text"
                        class="collection-banner-v2-text__subtitle"
                        style="color: {{ feedItem?.subtitle?.color }}"
                        >{{ feedItem?.subtitle?.text }}</span
                    >
                    <span
                        *ngIf="feedItem?.button?.title?.text"
                        class="underline-action-button"
                        style="cursor: pointer"
                        [ngStyle.xs]="{
                            fontSize: '13px'
                        }"
                        (click)="processLink(feedItem?.button?.link)"
                        >{{ feedItem?.button?.title?.text }}</span
                    >
                </div>
            </div>
            <a
                *ngIf="item?.layoutContent?.button?.title?.text"
                [routerLink]="[
                    item?.layoutContent?.button?.link | pageIdFromLink
                ]"
                [queryParams]="
                    item?.layoutContent?.button?.link | queryParamFromLink
                "
                style="text-decoration: none"
                [attr.aria-label]="
                    item?.layoutContent?.title?.text || 'button-link'
                "
            >
                <button
                    fxShow.gt-xs="true"
                    fxShow.xs="false"
                    mat-flat-button
                    class="button-v2"
                    style="background: {{
                        item?.layoutContent?.button?.background?.color
                    }};
            color:{{ item?.layoutContent?.button?.title?.color }}"
                    *ngIf="!!item?.layoutContent?.button"
                >
                    {{ item?.layoutContent?.button?.title?.text }}
                </button>
            </a>
        </div>
    </div>

    <!--TWO COL BANNER WITH TITLE-->

    <div
        *ngIf="
            item?.layoutType === '2-col-banner-with-title' &&
            item?.layoutContent?.feed.length > 0
        "
        ngClass.gt-xs="two-col-banner-with-title__desktop-margin"
        ngClass.xs="two-col-banner-with-title__mobile-margin"
    >
        <div
            fxLayoutAlign="space-between"
            [ngStyle.xs]="{ marginBottom: '16px' }"
            [ngStyle.gt-xs]="{ justifyContent: 'center' }"
        >
            <h1
                *ngIf="item?.layoutContent?.title?.text"
                class="two-col-banner-with-title__header"
                ngClass.gt-xs="two-col-banner-with-title__desktop-header"
                style="color:{{ item?.layoutContent?.title?.color }}"
                >{{ item?.layoutContent?.title?.text }}</h1
            >
            <a
                *ngIf="item?.layoutContent?.button?.title?.text"
                [routerLink]="[
                    item?.layoutContent?.button?.link | pageIdFromLink
                ]"
                [queryParams]="
                    item?.layoutContent?.button?.link | queryParamFromLink
                "
                style="text-decoration: none"
                [attr.aria-label]="
                    item?.layoutContent?.title?.text || 'button-link'
                "
            >
                <button
                    *ngIf="item?.layoutContent?.button?.title?.text"
                    fxShow.gt-xs="false"
                    fxShow.xs="true"
                    class="view-button"
                    style="color: {{
                        item?.layoutContent?.button?.title?.color
                    }}"
                    >{{ item?.layoutContent?.button?.title?.text }}</button
                >
            </a>
        </div>
        <p
            *ngIf="item?.layoutContent?.subtitle?.text"
            fxShow.xs="false"
            class="two-col-banner-with-title__sub-header"
            style="color:{{ item?.layoutContent?.subtitle?.color }}"
            [innerHTML]="item?.layoutContent?.subtitle?.text | lineBreak"
        ></p>
        <div
            fxLayout.gt-xs="row"
            fxLayout.xs="column"
            fxLayoutAlign="space-between"
            fxLayoutGap.xs="12px"
            [ngStyle.gt-xs]="{
                marginBottom: item?.layoutContent?.button?.title?.text
                    ? '50px'
                    : '0px',
                width: '-webkit-fill-available'
            }"
        >
            <div
                fxFlex="0 0 48.5%"
                fxFlex.xs="0 0 100%"
                fxLayout="column"
                *ngFor="let feedData of item?.layoutContent?.feed"
            >
                <a
                    *ngIf="feedData?.banner?.image"
                    [routerLink]="[feedData?.banner?.link | pageIdFromLink]"
                    [queryParams]="feedData?.banner?.link | queryParamFromLink"
                    [attr.aria-label]="feedData?.title?.text || 'banner-link'"
                >
                    <img
                        style="width: 100%"
                        src="{{ feedData?.banner?.image }}"
                        appImageCDN
                        [alt]="feedData?.title?.text || 'banner'"
                    />
                </a>
                <span
                    *ngIf="feedData?.title?.text"
                    class="two-col-banner-with-title__title"
                    ngClass.xs="two-col-banner-with-title__title__mobile"
                    style="color:{{ feedData?.title?.color }}"
                    >{{ feedData?.title?.text }}</span
                >
                <span
                    *ngIf="feedData?.button?.title?.text"
                    class="underline-action-button"
                    style="cursor: pointer"
                    [ngStyle.xs]="{
                        fontSize: '13px'
                    }"
                    (click)="processLink(feedData?.button?.link)"
                    >{{ feedData?.button?.title?.text }}</span
                >
            </div>
        </div>
        <a
            *ngIf="item?.layoutContent?.button?.title?.text"
            [routerLink]="[item?.layoutContent?.button?.link | pageIdFromLink]"
            [queryParams]="
                item?.layoutContent?.button?.link | queryParamFromLink
            "
            style="text-decoration: none"
            [attr.aria-label]="
                item?.layoutContent?.title?.text || 'button-link'
            "
        >
            <button
                fxShow.gt-xs="true"
                fxShow.xs="false"
                mat-flat-button
                class="button-v2"
                style="background: {{
                    item?.layoutContent?.button?.background?.color
                }};
              color:{{ item?.layoutContent?.button?.title?.color }}"
                *ngIf="!!item?.layoutContent?.button"
            >
                {{ item?.layoutContent?.button?.title?.text }}
            </button>
        </a>
    </div>

    <!--CATEGORY TAB SECTION LAYOUT-->

    <div
        *ngIf="
            item?.layoutType === 'category-tab-section' &&
            item?.layoutContent?.feed.length > 0
        "
        class="category-tab-section"
        [ngStyle.gt-xs]="{ padding: '0 34px 98px 34px' }"
        [ngStyle.xs]="{ padding: '0 16px 72px 16px' }"
    >
        <div
            *ngIf="item?.layoutContent?.title"
            [ngStyle.gt-xs]="{
                'margin-bottom': '50px'
            }"
            fxLayout.gt-xs="column"
            fxLayoutAlign.gt-xs="center center"
            fxLayoutAlign.xs="start"
            [ngStyle.xs]="{
                'margin-bottom': '24px'
            }"
        >
            <h1
                *ngIf="item?.layoutContent?.title?.text"
                class="category-tab-section__header"
                ngClass.gt-xs="category-tab-section__desktop-header"
                style="color:{{ item?.layoutContent?.title?.color }}"
                >{{ item?.layoutContent?.title?.text }}</h1
            >
            <p
                *ngIf="item?.layoutContent?.subtitle?.text"
                fxShow.xs="false"
                class="category-tab-section__sub-header"
                style="color:{{ item?.layoutContent?.subtitle?.color }}"
                [innerHTML]="item?.layoutContent?.subtitle?.text | lineBreak"
            ></p>
        </div>
        <div
            *ngIf="item?.layoutContent?.feed.length > 0"
            class="category-tab-group"
            ngClass.xs="category-tab-group-mobile"
        >
            <div
                fxLayout="column"
                [ngStyle.gt-xs]="{ gap: '50px' }"
                [ngStyle.xs]="{ gap: '24px' }"
                *ngIf="tabData"
            >
                <div fxLayout.xs>
                    <mat-tab-group
                        [animationDuration]="0"
                        [selectedIndex]="selectedTab"
                        [disableRipple]="true"
                        [disablePagination]="true"
                        [@.disable]="true"
                    >
                        <mat-tab
                            *ngFor="let tab of item?.layoutContent?.feed"
                            disabled
                        >
                            <ng-template mat-tab-label>
                                <span
                                    *ngIf="!isBot && tab.title.text"
                                    class="tab-header"
                                    (click)="processLink(tab.link)"
                                    >{{ tab.title.text }}
                                </span>
                                <a
                                    *ngIf="isBot && tab.title.text"
                                    class="tab-header"
                                    style="text-decoration: none"
                                    [routerLink]="[
                                        tab?.categoryTab?.button?.link
                                            | pageIdFromLink
                                    ]"
                                    [queryParams]="
                                        tab?.categoryTab?.button?.link
                                            | queryParamFromLink
                                    "
                                    [attr.aria-label]="
                                        tab?.title?.text || 'button-link'
                                    "
                                    >{{ tab.title.text }}
                                </a>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                    <div
                        fxShow.gt-xs="false"
                        fxShow.xs="true"
                        ngClass.xs="color-shade"
                    ></div>
                </div>
                <div
                    class="category-tab-group-content"
                    [ngStyle.xs]="{ 'flex-direction': 'column-reverse' }"
                >
                    <div
                        class="category-tab-group-products"
                        fxLayout="row wrap"
                        fxLayoutAlign="space-between"
                        [ngStyle.gt-xs]="{ width: '48.5%' }"
                        [ngStyle.xs]="{ width: '100%' }"
                        *ngIf="tabData?.categoryTab?.productList"
                    >
                        <div
                            *ngFor="
                                let variant of tabData?.categoryTab?.productList
                            "
                            [ngStyle.gt-xs]="{
                                width: '47%',
                                marginBottom: '24px'
                            }"
                            [ngStyle.xs]="{ width: '46%' }"
                        >
                            <a
                                *ngIf="variant?.banner.image"
                                [routerLink]="[
                                    variant?.banner?.link | pageIdFromLink
                                ]"
                                [queryParams]="
                                    variant?.banner?.link | queryParamFromLink
                                "
                                [attr.aria-label]="
                                    variant?.title?.text || 'banner-link'
                                "
                            >
                                <picture
                                    class="category-product-banner-image"
                                    [ngStyle.gt-xs]="{ height: '100%' }"
                                >
                                    <img
                                        class="category-banner-img"
                                        ngClass.xs="category-banner-img-mobile"
                                        src="{{ variant?.banner.image }}"
                                        appImageCDNWithOutHeight
                                        [alt]="variant?.title?.text || 'banner'"
                                    />
                                </picture>
                            </a>
                            <a
                                *ngIf="variant?.title?.text"
                                [routerLink]="[
                                    variant?.banner?.link | pageIdFromLink
                                ]"
                                [queryParams]="
                                    variant?.banner?.link | queryParamFromLink
                                "
                                style="text-decoration: none"
                                [attr.aria-label]="
                                    variant?.title?.text || 'banner-link'
                                "
                            >
                                <p
                                    *ngIf="variant?.title?.text"
                                    style="color: {{ variant?.title?.color }}"
                                    ngClass.gt-xs="text"
                                    ngClass.xs="text_mobile"
                                    >{{ variant?.title?.text }}</p
                                >
                            </a>
                        </div>
                    </div>
                    <div
                        class="category-tab-group-banner"
                        [ngStyle.gt-xs]="{ width: '48.5%' }"
                        [ngStyle.xs]="{ width: '100%' }"
                        *ngIf="tabData?.categoryTab?.banner?.image"
                    >
                        <picture
                            class="category-banner-image"
                            (click)="
                                processLink(tabData?.categoryTab?.banner?.link)
                            "
                        >
                            <img
                                class="category-banner-img"
                                [ngStyle.xs]="{ 'margin-bottom': '16px' }"
                                src="{{ tabData?.categoryTab?.banner?.image }}"
                                appImageCDNWithOutHeight
                                [alt]="tabData?.title?.text || 'banner'"
                            />
                        </picture>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center center">
                    <a
                        *ngIf="tabData?.categoryTab?.button?.title?.text"
                        [routerLink]="[
                            tabData?.categoryTab?.button?.link | pageIdFromLink
                        ]"
                        [queryParams]="
                            tabData?.categoryTab?.button?.link
                                | queryParamFromLink
                        "
                        style="text-decoration: none"
                        [attr.aria-label]="
                            tabData?.title?.text || 'button-link'
                        "
                    >
                        <button
                            mat-flat-button
                            class="button-v2"
                            style="background: {{
                                tabData?.categoryTab?.button?.background?.color
                            }};
            color:{{ tabData?.categoryTab?.button?.title?.color }}"
                            *ngIf="!!tabData?.categoryTab?.button"
                        >
                            {{ tabData?.categoryTab?.button?.title?.text }}
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!--HALF PRICE SALE SPECIAL LAYOUT-->

    <div
        *ngIf="item?.layoutType === '2-col-grid-with-title'"
        ngClass.gt-xs="two-col-grid-with-title__desktop-margin "
        ngClass.xs="two-col-grid-with-title__mobile-margin"
    >
        <div>
            <div
                [ngStyle.gt-xs]="{ 'justify-content': 'center' }"
                fxLayoutAlign.xs="space-between"
                [ngStyle.xs]="{ marginBottom: '16px' }"
                *ngIf="item?.layoutContent?.title?.text"
            >
                <h1
                    *ngIf="item?.layoutContent?.title?.text"
                    class="two-col-grid-with-title__title"
                    ngClass.gt-xs="two-col-grid-with-title__desktop-title"
                    style="color:{{ item?.layoutContent?.title?.color }}"
                    >{{ item?.layoutContent?.title?.text }}</h1
                >
                <a
                    *ngIf="item?.layoutContent?.button?.title?.text"
                    [routerLink]="[
                        item?.layoutContent?.button?.link | pageIdFromLink
                    ]"
                    [queryParams]="
                        item?.layoutContent?.button?.link | queryParamFromLink
                    "
                    style="text-decoration: none"
                    [attr.aria-label]="
                        item?.layoutContent?.title?.text || 'button-link'
                    "
                >
                    <button
                        *ngIf="item?.layoutContent?.button?.title?.text"
                        fxShow.gt-xs="false"
                        fxShow.xs="true"
                        class="view-button"
                        style="color: {{
                            item?.layoutContent?.button?.title?.color
                        }}"
                        >{{ item?.layoutContent?.button?.title?.text }}</button
                    >
                </a>
            </div>
            <p
                *ngIf="item?.layoutContent?.subtitle?.text"
                fxShow.xs="false"
                style="color: {{ item?.layoutContent?.subtitle?.color }}"
                class="two-col-grid-with-title__sub-title"
                [innerHTML]="item?.layoutContent?.subtitle?.text | lineBreak"
            ></p>
        </div>
        <div
            class="two-col-grid-with-title-banners"
            [ngStyle.gt-xs]="{ 'margin-bottom': '32px', gap: '30px' }"
            [ngStyle.xs]="{ 'column-gap': '16px', 'row-gap': '24px' }"
            *ngIf="item?.layoutContent?.feed"
        >
            <div
                fxFlex="0 0 48.59%"
                fxFlex.xs="0 0 47.5%"
                *ngFor="let feedData of item?.layoutContent?.feed"
            >
                <a
                    *ngIf="feedData?.banner?.image"
                    [routerLink]="[feedData?.banner?.link | pageIdFromLink]"
                    [queryParams]="feedData?.banner?.link | queryParamFromLink"
                    [attr.aria-label]="feedData?.title?.text || 'banner-link'"
                >
                    <img
                        style="width: 100%"
                        src="{{ feedData?.banner?.image }}"
                        appImageCDN
                        [alt]="feedData?.title?.text || 'banner'"
                    />
                </a>
                <span
                    fxShow.gt-xs="false"
                    fxShow.xs="true"
                    *ngIf="feedData?.title?.text"
                    class="two-col-grid-with-title-banners__title"
                    >{{ feedData?.title?.text }}</span
                >
            </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center">
            <a
                *ngIf="item?.layoutContent?.button?.title?.text"
                [routerLink]="[
                    item?.layoutContent?.button?.link | pageIdFromLink
                ]"
                [queryParams]="
                    item?.layoutContent?.button?.link | queryParamFromLink
                "
                style="text-decoration: none"
                [attr.aria-label]="
                    item?.layoutContent?.title?.text || 'button-link'
                "
            >
                <button
                    fxShow.gt-xs="true"
                    fxShow.xs="false"
                    mat-flat-button
                    class="button-v2"
                    style="background: {{
                        item?.layoutContent?.button?.background?.color
                    }};
            color:{{ item?.layoutContent?.button?.title?.color }}"
                    *ngIf="!!item?.layoutContent?.button"
                >
                    {{ item?.layoutContent?.button?.title?.text }}
                </button>
            </a>
        </div>
    </div>
    <div
        *ngIf="item.layoutType === '1-col-banner-with-side-padding'"
        style="margin: 0 16px"
        ngStyle.gt-xs="margin:0 34px"
    >
        <div
            class="one-col-banner-mobile-with-side-padding"
            ngClass.gt-xs="one-col-banner-desktop one-col-banner-desktop-side-padding "
        >
            <picture
                class="one-col-banner-image"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngClass]="{ 'image-banner-shimmer': showShimmer }"
            >
                <img
                    class="image-holder"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <!--Video-->
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{
                    item?.layoutContent?.banner?.image + posterImageCDN
                }}"
                style="
                    clip-path: inset(0px);
                    border: none;
                    position: absolute;
                    top: 0;
                    height: auto;
                    width: 100%;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
            <a
                [routerLink]="[
                    item?.layoutContent?.banner?.link | pageIdFromLink
                ]"
                [queryParams]="
                    item?.layoutContent?.banner?.link | queryParamFromLink
                "
                [attr.aria-label]="
                    item?.layoutContent?.title?.text || 'one-col-banner-link'
                "
            >
                <div
                    class="one-col-banner-content"
                    fxLayout="column"
                    fxLayout.gt-xs="row"
                >
                    <div
                        [fxFlex]="homepageService.getFlex(item?.layoutContent)"
                        [fxFlexOrder]="
                            homepageService.getFlexOrder(item?.layoutContent)
                        "
                        fxLayout="column"
                        [fxLayoutAlign]="
                            homepageService.getFlexAlign(item?.layoutContent)
                        "
                        [ngStyle.gt-xs]="
                            item?.layoutContent?.title?.text &&
                            item?.layoutContent?.button?.title?.text
                                ? {
                                      padding: homepageService.isAlignmentValid(
                                          item?.layoutContent?.alignment
                                      )
                                  }
                                : null
                        "
                        [ngStyle.xs]="
                            item?.layoutContent?.title?.text &&
                            item?.layoutContent?.button?.title?.text
                                ? { padding: '24px' }
                                : null
                        "
                    >
                        <h1
                            class="banner-heading"
                            [ngClass.lt-md]="{ 'mob-banner-heading': true }"
                            style="color:{{
                                item?.layoutContent?.title?.color
                            }}"
                            [ngStyle.gt-xs]="{
                                marginBottom: item?.layoutContent?.subtitle
                                    ?.text
                                    ? '0'
                                    : '12px'
                            }"
                        >
                            {{ item?.layoutContent?.title?.text }}
                        </h1>
                        <p
                            *ngIf="item?.layoutContent?.subtitle?.text"
                            fxShow.xs="false"
                            style="font-family:'Roboto Regular'; font-size: 16px; font-style: normal; font-weight: 400; line-height: 24px; margin:0 0 12px 0; color: {{
                                item?.layoutContent?.subtitle?.color
                            }}"
                            [innerHTML]="
                                item?.layoutContent?.subtitle?.text | lineBreak
                            "
                        ></p>
                        <button
                            mat-flat-button
                            class="button-v2"
                            style="background: {{
                                item?.layoutContent?.button?.background?.color
                            }};
              color:{{ item?.layoutContent?.button?.title?.color }}"
                            *ngIf="!!item?.layoutContent?.button"
                            (click)="
                                processLink(item?.layoutContent?.button?.link)
                            "
                        >
                            {{ item?.layoutContent?.button?.title?.text }}
                        </button>
                    </div>
                    <div #spacer fxFlex="0 1 60%" fxFlexOrder="0"></div>
                </div>
            </a>
        </div>
    </div>

    <!-- Top Categories -->
    <div *ngIf="item?.layoutType === 'top-categories'">
        <div
            fxLayoutAlign="center center"
            [ngStyle.xs]="{ margin: '0 16px 48px' }"
            [ngStyle.gt-xs]="{ margin: '0 0px 50px' }"
            *ngIf="item?.layoutContent?.title?.text"
            fxLayout="column"
        >
            <h1
                *ngIf="item?.layoutContent?.title?.text"
                class="top-categories-title__title"
                ngClass.gt-xs="top-categories-title__desktop-title"
                style="color:{{ item?.layoutContent?.title?.color }}"
                >{{ item?.layoutContent?.title?.text }}</h1
            >
            <div
                fxLayout="row wrap"
                ngClass.gt-xs="top-categories-title__desktop-grid"
                fxLayoutAlign="center"
            >
                <div
                    *ngFor="let categories of item?.layoutContent?.slider"
                    fxFlex.gt-xs="0 0 15%"
                    fxFlex.xs="0 0 25%"
                    ngStyle.gt-xs="margin: 0 45px;"
                >
                    <a
                        [routerLink]="[
                            categories?.banner?.link | pageIdFromLink
                        ]"
                        [queryParams]="
                            categories?.banner?.link | queryParamFromLink
                        "
                        [attr.aria-label]="
                            categories?.title?.text || 'banner-link'
                        "
                        style="text-decoration: none"
                    >
                        <picture fxLayout>
                            <img
                                src="{{ categories?.banner?.image }}"
                                style="width: 100%; margin-bottom: 8px"
                                [alt]="categories?.title?.text || 'banner'"
                            />
                        </picture>
                        <p
                            ngClass.xs="top-categories-title__sub-title-mobile"
                            ngClass.gt-xs="top-categories-title__sub-title"
                            style="color: {{ categories?.title?.color }};"
                        >
                            {{ categories?.title?.text }}
                        </p>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- slider-with-subtext-v3 -->
    <div
        *ngIf="item.layoutType === 'slider-with-subtext-v3'"
        class="slider-with-button-v3"
        ngClass.xs="slider-with-button-mobile-v3"
        fxLayout="column"
        fxLayoutAlign="center"
        [ngStyle.gt-xs]="{
            'margin-right': item?.layoutContent?.padding?.right
                ? item?.layoutContent?.padding?.right + 'px'
                : '34px',
            'margin-bottom': item?.layoutContent?.padding?.bottom
                ? item?.layoutContent?.padding?.bottom + 'px'
                : '98px',
            'margin-left': item?.layoutContent?.padding?.left
                ? item?.layoutContent?.padding?.left + 'px'
                : '34px'
        }"
    >
        <div
            fxLayoutAlign="space-between"
            [ngStyle.xs]="{
                marginBottom: '16px',
                marginRight: '16px'
            }"
            [ngStyle.gt-xs]="{
                marginBottom: '24px'
            }"
        >
            <h2
                *ngIf="item?.layoutContent?.title?.text"
                class="slider-with-button-v3__header"
                ngClass.gt-xs="slider-with-button-v3__desktop-header"
                style="color:{{
                    item?.layoutContent?.title?.color
                }}; margin-bottom: 0px"
                >{{ item?.layoutContent?.title?.text }}</h2
            >
            <button
                *ngIf="item?.layoutContent?.button?.title?.text"
                fxShow.gt-xs="true"
                fxShow.xs="true"
                class="view-button"
                (click)="processLink(item?.layoutContent?.button?.link)"
                style="color: {{ item?.layoutContent?.button?.title?.color }}"
                >{{ item?.layoutContent?.button?.title?.text }}</button
            >
        </div>
        <app-custom-scrollbar
            scrollbarClass="hp-v2-custom-scrollbar"
            scrollContainerSelector=".slider-with-subtext-v3-row"
        >
            <div
                fxShow.gt-xs="false"
                fxLayout="row"
                fxLayoutAlign="flex-start"
                style="overflow-x: auto"
                class="slider-with-subtext-v3-row"
            >
                <div
                    fxLayout="column"
                    ngClass.gt-xs="slider-with-banner"
                    *ngFor="let slide of item?.layoutContent?.slider"
                    [ngClass]="{ 'image-slider-shimmer': showShimmer }"
                    fxFlex.gt-xs="0 0 22%"
                    fxFlex.xs="0 0 55%"
                    [ngStyle.gt-xs]="{ paddingRight: '44px' }"
                    [ngStyle.xs]="{
                        paddingRight: '12px',
                        marginBottom: '20px'
                    }"
                >
                    <a
                        class="anchor-tag"
                        [routerLink]="[slide?.banner?.link | pageIdFromLink]"
                        [queryParams]="slide?.banner?.link | queryParamFromLink"
                        [attr.aria-label]="slide?.title?.text || 'banner-link'"
                    >
                        <picture
                            class="slider-with-banner-image"
                            ngClass.xs="{slider-with-banner-image__mobile}"
                        >
                            <img
                                class="slider-with-banner-image-holder"
                                [ngStyle.xs]="{
                                    marginBottom: '12px'
                                }"
                                src="{{ slide?.banner?.image }}"
                                appImageCDN
                                [alt]="slide?.title?.text || 'banner'"
                            />
                        </picture>
                        <div
                            style=" background:#{{
                                item?.layoutContent?.banner?.scrim?.color +
                                    item?.layoutContent?.banner?.scrim?.alpha
                            }}"
                            class="slider-with-button-content"
                            fxLayout="column"
                            fxLayoutAlign="center flex-start"
                        >
                            <span
                                *ngIf="slide.subtitle"
                                style="text-align: left; margin-bottom: 7px; font-size: 13px; color: {{
                                    slide.subtitle.color
                                }}"
                                [ngStyle.xs]="{
                                    marginBottom: '5px',
                                    fontSize: '12px'
                                }"
                            >
                                {{ slide?.subtitle?.text }}
                            </span>
                            <h1
                                *ngIf="slide.title"
                                class="slider-title-v2"
                                style="text-align: left; font-size: 16px; color: {{
                                    slide.title.color
                                }}"
                                [ngStyle.xs]="{
                                    fontSize: '13px',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    width: '100%'
                                }"
                            >
                                {{ slide?.title?.text }}
                            </h1>
                        </div>
                    </a>
                </div>
            </div>
        </app-custom-scrollbar>
        <swiper
            fxShow.xs="false"
            style="width: 100%"
            [slidesPerView]="5"
            [slidesPerGroup]="5"
            [speed]="1300"
            [navigation]="true"
            [spaceBetween]="16"
            [effect]="'flip'"
            (swiper)="homepageService.onSwiper($event)"
            (slideChange)="homepageService.onSlideChange($event)"
        >
            <ng-template
                swiperSlide
                *ngFor="let feedItem of item?.layoutContent?.slider"
            >
                <a
                    *ngIf="feedItem?.banner?.image"
                    [routerLink]="[feedItem?.banner?.link | pageIdFromLink]"
                    [queryParams]="feedItem?.banner?.link | queryParamFromLink"
                    [attr.aria-label]="feedItem?.title?.text || 'banner-link'"
                >
                    <picture
                        [ngClass]="{
                            'image-slider-v2-shimmer': showShimmer
                        }"
                    >
                        <img
                            style="width: 100%; cursor: pointer"
                            [ngStyle.gt-xs]="{ marginBottom: '14.4px' }"
                            src="{{ feedItem?.banner?.image }}"
                            appImageCDN
                            [alt]="feedItem?.title?.text || 'banner'"
                        />
                    </picture>
                </a>
                <div fxLayout="column">
                    <span
                        *ngIf="feedItem?.subtitle"
                        style="text-align: left; margin-bottom: 7px; font-size: 13px; color: {{
                            feedItem?.subtitle?.color
                        }}"
                        [ngStyle.xs]="{
                            marginBottom: '5px',
                            fontSize: '12px'
                        }"
                    >
                        {{ feedItem?.subtitle?.text }}
                    </span>
                    <a
                        *ngIf="feedItem?.title?.text"
                        [routerLink]="[feedItem?.banner?.link | pageIdFromLink]"
                        [queryParams]="
                            feedItem?.banner?.link | queryParamFromLink
                        "
                        style="text-decoration: none"
                        [attr.aria-label]="
                            feedItem?.title?.text || 'banner-link'
                        "
                    >
                        <span
                            [ngStyle.gt-xs]="{
                                '-webkit-line-clamp': '2',
                                fontSize: '13px',
                                overflow: 'hidden',
                                display: '-webkit-box',
                                '-webkit-box-orient': 'vertical',
                                textOverflow: 'ellipsis',
                                width: '100%'
                            }"
                            style="color: {{ feedItem?.title?.color }}"
                            *ngIf="feedItem?.title"
                            class="slider-title"
                        >
                            {{ feedItem?.title?.text }}
                        </span>
                    </a>
                </div>
            </ng-template>
        </swiper>
    </div>

    <!-- slider-collection-banners -->
    <div
        *ngIf="item.layoutType === 'slider-collection-banners'"
        class="slider-with-button-v3"
        ngClass.xs="slider-with-button-mobile-v3"
        fxLayout="column"
        fxLayoutAlign="center"
        [ngStyle.gt-xs]="{ margin: '0 34px 98px' }"
    >
        <div
            *ngIf="item?.layoutContent?.title?.text"
            fxLayoutAlign="space-between"
            [ngStyle.xs]="{
                marginBottom: '16px',
                marginRight: '16px'
            }"
            [ngStyle.gt-xs]="{
                marginBottom: '24px'
            }"
        >
            <h2
                *ngIf="item?.layoutContent?.title?.text"
                class="slider-with-button-v3__header"
                ngClass.gt-xs="slider-with-button-v3__desktop-header"
                style="color:{{
                    item?.layoutContent?.title?.color
                }}; margin-bottom: 0px"
                >{{ item?.layoutContent?.title?.text }}</h2
            >
            <button
                *ngIf="item?.layoutContent?.button?.title?.text"
                fxShow.gt-xs="true"
                fxShow.xs="true"
                class="view-button"
                (click)="processLink(item?.layoutContent?.button?.link)"
                style="color: {{ item?.layoutContent?.button?.title?.color }}"
                >{{ item?.layoutContent?.button?.title?.text }}</button
            >
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="flex-start"
            style="overflow-x: auto"
            ngClass.xs="scrollBar-v2"
            ngClass.gt-xs="scrollBar"
            fxLayoutAlign.gt-xs="space-between"
        >
            <div
                fxLayout="column"
                ngClass.gt-xs="slider-with-banner-v3"
                *ngFor="let slide of item?.layoutContent?.slider"
                [ngClass]="{ 'image-slider-shimmer': showShimmer }"
                fxFlex.gt-xs="0 0 32%"
                fxFlex.xs="0 0 75%"
                [ngStyle.xs]="{
                    paddingRight: '13px',
                    marginBottom: iosWeb ? '0' : '20px'
                }"
            >
                <a
                    *ngIf="slide?.banner?.image"
                    class="anchor-tag"
                    [routerLink]="[slide?.banner?.link | pageIdFromLink]"
                    [queryParams]="slide?.banner?.link | queryParamFromLink"
                    [attr.aria-label]="slide?.title?.text || 'banner-link'"
                >
                    <picture
                        class="slider-with-banner-image"
                        ngClass.xs="{slider-with-banner-image__mobile}"
                    >
                        <img
                            class="slider-with-banner-image-holder"
                            [ngStyle.xs]="{
                                marginBottom: '12px'
                            }"
                            src="{{ slide?.banner?.image }}"
                            appImageCDN
                            [alt]="slide?.title?.text || 'banner'"
                        />
                    </picture>
                </a>
            </div>
        </div>
    </div>
</div>
